import { Component } from '@angular/core';
import { FuncsService } from '../services/funcs.service';
import { CustomerService } from '../services/customer.service';
import { Customer, CustomerCurrent } from '../data/customer';

@Component({
  selector: 'app-fleet-customer',
  templateUrl: './fleet-customer.component.html',
  styleUrl: './fleet-customer.component.css',
  standalone: false
})
export class FleetCustomerComponent {

  finCode: string = "";
  errormsg: string = "";
  msg: string = "";

  constructor(
    private funcs: FuncsService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.msg = "";
    this.errormsg = "";
    this.funcs.checkAdmin();
    this.funcs.currentCustomer(CustomerCurrent);
  }

  createAccount() {
    this.msg = "";
    this.errormsg = "";
    if (this.finCode == "") {
      this.errormsg = "FIN Code should not be empty.";
      return;
    }
    if (this.finCode != "") {
      this.customerService.addFleetCustomer(this.finCode, CustomerCurrent.username).subscribe((status) => {        
        if (status == 1) {
          this.msg = "Fleet account created.";
        } else if (status == 0) {
          this.msg = "Error creating account.";
        } else if (status == 123) {
          this.msg = "Account already exists!";
        }
      });
    }
  }
}
